import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchReceivableAmount } from "redux/slices/home/homeSlice";

// hooks
import { useTodayPaymentQuery } from "pages/Sales/_hooks/useTodayPaymentQuery";

// components
import {
  TodaysSales,
  TodaysReservations,
  ReceivableCard,
  SmallCards,
  TodaysVouchers,
  AdBanner,
} from "components/home";

const HomeContents = () => {
  const {
    todaysReservations,
    todaysVouchers,
    receivableSum,
    appLinkCount,
    qnaCount,
    errors,
  } = useSelector((state) => state.home);
  const dispatch = useDispatch();
  const { seqPartner, branchUseYn, seqPartnerBranch } = useSelector(
    (state) => state.partner
  );
  const todaysSales = useTodayPaymentQuery();
  const isAll = branchUseYn === "Y" && seqPartnerBranch === 0;

  return (
    <>
      <TodaysReservations reservationData={todaysReservations} />

      <AdBanner />

      <TodaysSales
        data={todaysSales.data}
        isLoading={todaysSales.isLoading}
        isError={todaysSales.isError}
        onRefresh={() => todaysSales.refetch()}
      />

      <TodaysVouchers voucherData={todaysVouchers} isAll={isAll} />

      <ReceivableCard
        amount={receivableSum}
        isAll={isAll}
        isError={!!errors.receivable}
        onRefresh={() =>
          dispatch(
            fetchReceivableAmount(seqPartner, seqPartnerBranch, branchUseYn)
          )
        }
      />

      <SmallCards appLinkCount={appLinkCount} qnaCount={qnaCount} />
    </>
  );
};

export default HomeContents;
